import React from "react"
import { graphql, useFragment } from "react-relay"

import styles from "./IntegrationSyncDescription.module.css"

import { IntegrationSyncDescription_integration$key } from "./__generated__/IntegrationSyncDescription_integration.graphql"

import { TangramPersonBalancing, TangramPersonLeaping } from "~/common/tangrams"
import { TangramPersonFlying } from "~/common/tangrams/tangramPersonFlying"

import { IntegrationSyncStatus } from "./IntegrationSyncStatus"

type Props = {
  integration: IntegrationSyncDescription_integration$key
  title?: string
  description: React.ReactNode
  onOpenSyncHistory: () => void
}

const IntegrationSyncDescription = (props: Props) => {
  const integration = useFragment(
    graphql`
      fragment IntegrationSyncDescription_integration on integration {
        id
        ...IntegrationSyncStatus_integration
      }
    `,
    props.integration,
  )

  const { title, description, onOpenSyncHistory } = props

  return (
    <div className={styles.container}>
      <div className={styles.tangrams}>
        <TangramPersonLeaping />
        <TangramPersonBalancing />
        <TangramPersonFlying />
      </div>
      <div className={styles.title}>{title || "Just a few more minutes!"}</div>
      <div className={styles.description}>{description}</div>
      <IntegrationSyncStatus
        integration={integration}
        onOpenSyncHistory={onOpenSyncHistory}
      />
    </div>
  )
}

export default IntegrationSyncDescription
